import React from 'react';
import accounting from 'accounting';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

import {
    Card,
    Row,
    Col,
    Table,
    Checkbox,
    Button,
    message,
    Popconfirm
} from 'antd';

import {
    _getQbPaymentMethods,
    _getQbDepositToAccounts,
    _getEntityCreditInfo,
    _postSpendEvent,
    _postWithdrawCredit,
    _getCreditTxns,
    _getDebitTxns,
} from '../../services'

import './index.css'

import WithdrawModal from './withdraw-modal';

import { ADMIN_URL } from '../../index'
class CreditOverviewProfile extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            entity: false,
            creditBalance: [],
            outstandingDebit: [],

            invoiceList: [],
            loading: true,
            totalAmount: [],

            withdrawModalVisible: false,

            creditTxns: [],
            showCreditTxns: false,
            debitTxns: [],
            showDebitTxns: false,

            paymentMethods: false,
            depositToAccounts: false,
            
        }
    }

    render() {

        return (
            <div>
                <Row gutter={48}>
                    <Card>
                        <Col span={6}>
                            {this.renderHeaderInfo()}
                        </Col>
                        <Col span={6}>
                            {this.renderCreditBalanceTable()}
                        </Col>
                        <Col span={6}>
                            {this.renderDebitTotalTable()}
                        </Col>
                        <Col span={6}>
                            {this.renderActionButtons()}
                        </Col>
                    </Card>
                </Row>

                <Row>
                    <Card
                        title={
                            <div style={{display: 'flex'}}>
                                <h3 style={{marginRight: 8}}>Credit Transactions</h3>
                                {this.state.showCreditTxns ? <a onClick={() => this.toggleShowCredit(false)}>Hide</a> : <a onClick={() => this.toggleShowCredit(true)}>Show</a>}
                            </div>
                            }>
                        {this.state.showCreditTxns && this.renderTxns('credit')}
                    </Card>
                </Row>
                <Row>
                    <Card
                        title={
                            <div style={{display: 'flex'}}>
                                <h3 style={{marginRight: 8}}>Debit Transactions</h3>
                                {this.state.showDebitTxns ? <a onClick={() => this.toggleShowDebit(false)}>Hide</a> : <a onClick={() => this.toggleShowDebit(true)}>Show</a>}
                            </div>
                            }>
                        {this.state.showDebitTxns && this.renderTxns('debit')}
                    </Card>
                </Row>

                <Row>
                    <Card>
                        {this.renderOutstandingDebitTable()}
                    </Card>
                </Row>

                <WithdrawModal 
                    paymentMethods={this.state.paymentMethods}
                    depositToAccounts={this.state.depositToAccounts}
                    visible={this.state.withdrawModalVisible}
                    currencies={this.state.creditBalance.map(_creditBalance => _creditBalance.currency)}
                    closeModal={this.closeWithdrawModal}
                    handleWithdrawConfirm={this.handleWithdrawConfirm}
                    />
            </div>
        )
    }
    
    componentWillMount() {
        Promise.all([
            _getQbPaymentMethods(),
			_getQbDepositToAccounts(),
        ])
        .then(([paymentMethodsRes, depositToAccountsRes]) => {
            
            const { paymentMethods } = paymentMethodsRes.data
            const { depositToAccounts } = depositToAccountsRes.data
            
            this.setState({
                paymentMethods,
                depositToAccounts
            })
            
        })
    }

    componentDidMount() {
        this.getEntityCreditInfo()
        this.getCreditTxns()
        this.getDebitTxns()
    }
    
    getEntityCreditInfo = () => {
        const { entityType, entityId } = this.props.match.params

        this.setState({
            loading: true
        })
        _getEntityCreditInfo({ entityType, entityId })
        .then(response => {
            this.setState({
                entity: response.data.entity,
                creditBalance: response.data.creditBalance,
                outstandingDebit: response.data.outstandingDebit,
                loading: false,
                invoiceList: [],
                totalAmount: []
            })
        })
    }

    getCreditTxns = () => {

        const { entityType, entityId } = this.props.match.params;

        _getCreditTxns({ entityType, entityId })
        .then(_creditTxns => {
            this.setState({
                creditTxns: _creditTxns.data
            })
        })
    }

    getDebitTxns = () => {

        const { entityType, entityId } = this.props.match.params;

        _getDebitTxns({ entityType, entityId })
        .then(_debitTxns => {
            this.setState({
                debitTxns: _debitTxns.data
            })
        })
    }

    renderHeaderInfo = () => {
        
        const { entityType, entityId } = this.props.match.params
        const { entity } = this.state

        return (
            <Row>
                <Col>
                    <Row gutter={16} type="flex">
                        <Col span={8}> <div className="edc-row label">Entity Type:</div> </Col>
                        <Col span={16}> <div className="edc-row">{entityType.toUpperCase()}</div> </Col>
                    </Row>
                    <Row gutter={16} type="flex">
                        <Col span={8}> <div className="edc-row label">Entity Id:</div> </Col>
                        <Col span={16}> <div className="edc-row">{entityId}</div> </Col>
                    </Row>
                    <Row gutter={16} type="flex">
                        <Col span={8}> <div className="edc-row label">Entity Name:</div> </Col>
                        <Col span={16}> <div className="edc-row">{entity && entity.name}</div> </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

    renderTxns = (type) => {

        const { creditTxns, debitTxns, loading } = this.state;

        const columns = [{
            title: 'Event Type',
            dataIndex: 'eventType',
        },{
            title: 'Created At',
            dataIndex: 'createdAt',
            render: (createdAt) => moment(createdAt).format('LLL')
        },{
            title: 'Actor Type',
            dataIndex: 'actorType',
        },{
            title: "Actor Id",
            dataIndex: 'actorId',
        },{
            title: "Amount",
            dataIndex: 'amount',
            render: (amount) => accounting.formatMoney( amount, '$', 2)
        },{
            title: "Currency",
            dataIndex: 'currency',
        },{
            title: "Invoice Num",
            dataIndex: 'invoiceNum',
        }]

        return (
            <Table
                loading={loading}
                dataSource={type=='credit' ? creditTxns : debitTxns}
                columns={columns}
                pagination={{
                    limit: 10
                }}
                bodyStyle={{padding: 0}}
            />
        )
    }

    renderCreditBalanceTable = () => {

        const {loading, creditBalance} = this.state;

        const columns = [{
            title: 'Currency',
            dataIndex: 'currency',
        },{
            title: "Amount",
            dataIndex: 'amount',
            render: (amount) => accounting.formatMoney( amount, '$', 2)
        }]

        return (
            <Table
                loading={loading}
                dataSource={creditBalance}
                columns={columns}
                pagination={false}
                bodyStyle={{padding: 0}}
                title={() => 'Credit Balance'}
            />
        )
    }

    renderDebitTotalTable = () => {

        const {loading, totalAmount} = this.state;

        const columns = [{
            title: 'Currency',
            dataIndex: 'currency',
        },{
            title: "Amount",
            dataIndex: 'amount',
            render: (amount) => accounting.formatMoney( amount, '$', 2)
        }]

        return (
            <Table
                loading={loading}
                dataSource={totalAmount}
                columns={columns}
                pagination={false}
                bodyStyle={{padding: 0}}
                title={() => 'Debit Total'}
            />
        )
    }

    renderActionButtons = () => {
        return (
            <div>
                <Popconfirm
                    title="Confirm Payment?"
                    onConfirm={() => this.handleSetPaidClicked()}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button>Set Paid</Button>
                </Popconfirm>
                <Button
                    type="primary"
                    style={{ marginLeft: 8 }}
                    onClick={() => this.handleWithdrawClicked()}
                >
                    Withdraw
                </Button>
            </div>
        )
    }

    renderOutstandingDebitTable = () => {

        const {loading, outstandingDebit, invoiceList} = this.state;

        const columns = [{
            title: 'Invoice',
            dataIndex: 'invoiceNum',
        },{
            title: "Currency",
            dataIndex: 'currency'
        },{
            title: "Amount",
            dataIndex: 'amount',
            render: (amount) => accounting.formatMoney( amount, '$', 2)
        },{
            key: 'checkbox',
            title: <Checkbox
                // disabled={readOnly}
                checked={this.getAllChecked()}
                onChange={(e)=>this.handleCheckAll(e.target.checked)}
            />,
            dataIndex: 'invoiceNum',
            render: (invoiceNum, record) => {

                return(
                    <Checkbox
                        // disabled={readOnly || record.paid}
                        checked={invoiceList.includes(record.invoiceNum)}
                        onChange={(e)=>this.handleCheck({invoiceNum, checked: e.target.checked})}
                    />
                )
            }
        }]

        return (
            <Table
                loading={loading}
                dataSource={outstandingDebit}
                columns={columns}
                pagination={false}
            />
        )
    }

    getAllChecked = () => {

        const { invoiceList, outstandingDebit } = this.state

        let allChecked = true

        outstandingDebit.map( _outstandingDebit => {
            if( !invoiceList.includes( _outstandingDebit.invoiceNum ) ){
                allChecked = false
            }
        })

        return allChecked
    }

    handleCheck = ({invoiceNum, checked}) => {

        const { invoiceList } = this.state

        if( !checked ){
            this.setState({
                invoiceList: invoiceList.filter( _invoiceNum => _invoiceNum != invoiceNum ),
            },this.updateInvoiceListDetails)
        } else{
            this.setState({
                invoiceList: [...invoiceList, invoiceNum],
            },this.updateInvoiceListDetails)
        }

    }

    handleCheckAll = (checked) => {

        const {invoiceList, outstandingDebit} = this.state

        if( checked ){
            this.setState({
                invoiceList: outstandingDebit.map( _outstandingDebit => _outstandingDebit.invoiceNum ),
            },this.updateInvoiceListDetails)
        } else {
            this.setState({
                invoiceList: [],
            },this.updateInvoiceListDetails)
        }

    }

    updateInvoiceListDetails = () => {
        // Updates totalAmount and refNumbers of the selected lines
        const {invoiceList, outstandingDebit} = this.state

        let totalAmount = outstandingDebit
        .filter(_outstandingDebit => invoiceList.includes(_outstandingDebit.invoiceNum))
        .reduce((acc,cur)=> {
            if (!acc[cur.currency]) {
                acc[cur.currency] = {
                    currency: cur.currency,
                    amount: 0.0
                }
            }
            acc[cur.currency].amount += parseFloat(cur.amount)
            return acc
        },{})

        this.setState({
            totalAmount: Object.values(totalAmount),
        })
    }
    
    handleWithdrawClicked = () => {
        this.openWithdrawModal()
    }

    handleWithdrawConfirm = ({totalAmount}) => {

        const { entityType, entityId } = this.props.match.params

        var creditSufficient = this.checkIfCreditSufficient({totalAmount})

        if (!creditSufficient) {
            message.error('Insufficient Credit!', 10)
            return
        }

        console.log({totalAmount})

        _postWithdrawCredit({
            entityType: entityType,
            entityId: entityId,
            currency: totalAmount[0].currency,
            amount: totalAmount[0].amount,
            paymentMethodId: totalAmount[0].activePaymentMethodId,
            depositToId: totalAmount[0].activeDepositToId,
        })
        .then(_creditTxn => {
            console.log({_creditTxn})
            this.getEntityCreditInfo()
            this.closeWithdrawModal()
            window.open(`${ADMIN_URL}/finance/refunds`)
        })
    }

    handleSetPaidClicked = () => {

        const { entityType, entityId } = this.props.match.params
        const { invoiceList } = this.state

        var creditSufficient = this.checkIfCreditSufficient({totalAmount: this.state.totalAmount})

        if (!creditSufficient) {
            message.error('Insufficient Credit!', 10)
            return
        }

        if (invoiceList.length == 0) {
            message.error('No Invoices selected!', 10)
            return 
        }

        _postSpendEvent({
            entityType,
            entityId,
            invoiceList
        })
        .then(response => {
            message.success('Payment success!',10)
            this.getEntityCreditInfo()
            this.getCreditTxns()
            this.getDebitTxns()
        })


    }

    // Check if credit in every currency wallet is sufficient to fulfill totalAmount (debit amounts)
    checkIfCreditSufficient = ({ totalAmount }) => {
        console.log({totalAmount})
        const { creditBalance } = this.state

        var creditSufficient = totalAmount.every(_totalAmount => {

            var correspondingCreditBalance = creditBalance.filter(_creditBalance => {
                return _creditBalance.currency == _totalAmount.currency
            })

            // If no corresponding currency credit Balance
            if (!correspondingCreditBalance) { return false }
            // If corresponding currency credit amount, check if sufficient
            if (correspondingCreditBalance && correspondingCreditBalance[0]) {
                return  ( Math.round((parseFloat(correspondingCreditBalance[0].amount)  + Number.EPSILON) * 100) / 100 ) >= ( Math.round((parseFloat(_totalAmount.amount)  + Number.EPSILON) * 100) / 100 )
            }
        })

        return creditSufficient
    }

    openWithdrawModal = () => {
        console.log("OPNE MODAL")
        this.setState({
            withdrawModalVisible: true
        })
    }

    closeWithdrawModal = () => {
        console.log("CLOSE MODAL")
        this.setState({
            withdrawModalVisible: false
        })
    }

    toggleShowCredit = (show) => {
        this.setState({
            showCreditTxns: show
        })
    }
    toggleShowDebit = (show) => {
        this.setState({
            showDebitTxns: show
        })
    }
}

export default withRouter(CreditOverviewProfile)


// WEBPACK FOOTER //
// ./src/components/credit-overview/profile.js